import React from "react";
import { Card, Accordion } from "react-bootstrap";

export default function Step8GrommetOne({
  windowWidthPanelType,
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  step6,
  widthCart,
  step5,
  step3A0,
  step6A,
  setStep6A,
  setStep6,
  selectChanged,
  setExtendedTitle,
  extendedTitle,
  setDeps,
  setCart,
  inputs,
  pageLanguage,
  NextStep,
  modalHandleShow,
  setPanelSheerWarningTemp,
  setStep6BHead,
  step8B,
  setStep8,
  setHardwareNextStep,
  step6BHead,
  tracksList,
  step2A,
  step8,
  setStep6B,
  step6B,
  step6CHead,
  setStep6CHead,
  step6C,
  setStep6C,
  step8C,
  PopoverStickOnHover,
  popoverThumbnailHover,
  popoverImages,
  step2B,
  tracksList2,
  step2C,
  setPanelPLWarningTemp,
  step3,
}) {
  // Privacy header (step2C) is only required when sheer is not None
  const needsStep2C = step2B !== "None";

  // Info text vs panel grid: empty Step2A/2B must show the message, not the options
  const showPanelTypeInfo =
    step2A === "" ||
    step2B === "" ||
    widthCart === undefined ||
    step5 === "" ||
    step3A0 === "" ||
    (needsStep2C && step2C === "");
  const showPanelTypeGrid =
    step2A !== "" &&
    step2B !== "" &&
    widthCart !== undefined &&
    step5 !== "" &&
    (!needsStep2C || step2C !== "");

  let panelTypeInfoText;
  if (step2A === "") {
    panelTypeInfoText = t("panel_type_text1_new");
  } else if (needsStep2C && step2C === "") {
    panelTypeInfoText = t("panel_type_text1_new_step2C");
  } else if (step2B === "") {
    panelTypeInfoText = t("panel_type_text1_new_step2B");
  } else if (widthCart === undefined && step5 === "" && step3A0 === "") {
    panelTypeInfoText = t("panel_type_text1");
  } else if (widthCart === undefined && step5 !== "" && step3A0 === "") {
    panelTypeInfoText = t("panel_type_text2");
  } else if (widthCart === undefined && step5 !== "" && step3A0 !== "") {
    panelTypeInfoText = t("panel_type_text3");
  } else if (widthCart === undefined && step5 === "" && step3A0 !== "") {
    panelTypeInfoText = t("panel_type_text4");
  } else if (step5 === "") {
    panelTypeInfoText = t("panel_type_text5");
  }

  return (
    <Card>
      <Card.Header>
        <ContextAwareToggle
          eventKey="6"
          stepNum={step5 === "Full" && step3 === "false" ? t("7") : t("8")}
          stepTitle={t("grommet_step6_Drapery")}
          stepRef="6"
          type="1"
          required={requiredStep["6"]}
          stepSelected={stepSelectedLabel["6"] === undefined ? "" : stepSelectedLabel["6"]}
        />
      </Card.Header>
      <Accordion.Collapse eventKey="6">
        <Card.Body>
          <div className={showPanelTypeInfo ? "card_body card_body_info" : "noDisplay"}>
            <div className="card_body_info_header">
              <h1 className="card_body_info_header_title">{t("more_info")}</h1>
            </div>
            <hr />
            <div className="card_body_info_body">
              <p className="card_body_info_text">{panelTypeInfoText}</p>
            </div>
            <NextStep currentStep="6" eventKey="7">
              {t("NEXT STEP")}
            </NextStep>
          </div>

          <div
            className={
              showPanelTypeGrid ? "card_body_panel_type special_farsi_card_body" : "noDisplay"
            }
          >
            {/* drapery panel type */}
            <div className="card_body card_body_radio Customize_Style_container">
            {parseInt(windowWidthPanelType) > 160  && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text checkBoxPanelType">{t("title_step8_panel_type")}</span>
                      </div>
                    )}
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title">{t("Drapery Panel Type")}</p>
                <div
                  className={
                    (step5 === "Decorative" || step5 === "Full") &&
                    parseInt(windowWidthPanelType) > 160
                      ? "grommet_curtain_button_container grommet_curtain_button_container_separated"
                      : "noDisplay"
                  }
                >
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn dk_curtain_symmetric_button_on`}
                    >
                        <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button className={`dk_curtain_symmetric_button_right btn crossed`}>
                    <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
                <div
                  className={
                    parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                      ? "box33 radio_style"
                      : "noDisplay"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                        : require("../../Images/drapery/grommet/panel_type_left.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Single Panel")}
                    value="1"
                    name="step6A"
                    ref-num="6"
                    id="6A1"
                    checked={step6A === "Single Panel"}
                    onChange={(e) => {
                      setStep6A("Single Panel");
                      setStep6("Customize Style Per Curtain");

                      let tempExtended = extendedTitle;
                      tempExtended["6"] = [
                        parseInt(windowWidthPanelType) < 160
                          ? t("Drapery Panel Single Panel")
                          : t("Drapery Panel Rod Single Panel, Left2"),
                      ];

                      setExtendedTitle(tempExtended);
                      if (step2B === "None") {
                        setDeps("", "6,6A");
                      } else {
                        setDeps("", "6A");
                      }
                      setCart("PanelTypeA", "Single Panel");
                    }}
                    ref={(ref) => (inputs.current["6A1"] = ref)}
                  />
                  <label htmlFor="6A1">{t("Single Panel")}</label>
                </div>
                <div
                  className={
                    step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 160
                        ? parseInt(windowWidthPanelType) > 320
                          ? "noDisplay"
                          : "box33 radio_style radio_recommended wide_panel_type"
                        : "box33 radio_style"
                      : "box33 radio_style"
                  }
                >
                  <img
                    src={
                      step5 === "Full"
                        ? parseInt(windowWidthPanelType) > 160
                          ? pageLanguage === "fa"
                            ? require("../../Images/drapery/grommet/panel_type_both2.svg").default
                            : require("../../Images/drapery/grommet/panel_type_both2.svg").default
                          : pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Pair, Split Draw")}
                    value="5"
                    name="step6A"
                    ref-num="6"
                    id="6A5"
                    checked={step6A === "Pair, Split Draw"}
                    onChange={(e) => {
                      setStep6A("Pair, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][0] = [
                        parseInt(windowWidthPanelType) < 160
                          ? t("Drapery Panel Pair, Split Draw")
                          : t("Drapery Panel Rod Pair, Split Draw"),
                      ];
                      setExtendedTitle(tempExtended);
                      setCart("PanelTypeA", "Pair, Split Draw");
                      if (step2B === "None") {
                        setDeps("", "6,6A");
                      } else {
                        setDeps("", "6A");
                      }
                      if (step5 === "Full" && parseInt(windowWidthPanelType) > 320) {
                        modalHandleShow("panelTypeWarning");
                      }
                    }}
                    ref={(ref) => (inputs.current["6A5"] = ref)}
                  />
                  <label htmlFor="6A5">{t("Pair, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                    {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                  </div> */}
                </div>
              </div>


              <div
                className={
                  step5 === "Full" && parseInt(windowWidthPanelType) > 320 ? "box100" : "noDisplay"
                }
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                }}
              >
                <div
                  className={
                    step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                        : require("../../Images/drapery/grommet/panel_type_four.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Four Panel, Split Draw")}
                    value="6"
                    name="step6A"
                    ref-num="6"
                    id="6A7"
                    checked={step6A === "Four Panel, Split Draw"}
                    onChange={(e) => {
                      setStep6A("Four Panel, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"] = tempExtended["6"] || [];
                      tempExtended["6"][0] = t("Drapery Four Panel, Split Draw");
                      setExtendedTitle(tempExtended);
                      setDeps("", "6A");
                      setCart("PanelTypeA", "Four Panel, Split Draw");
                    }}
                    ref={(ref) => (inputs.current["6A7"] = ref)}
                  />
                  <label htmlFor="6A7">{t("Four Panel, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
                </div>
                <div
                  className={
                    step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                        : require("../../Images/drapery/grommet/panel_type_three.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Three Panel, Split Draw")}
                    value="6"
                    name="step6A"
                    ref-num="6"
                    id="6A6"
                    checked={step6A === "Three Panel, Split Draw"}
                    onChange={(e) => {
                      setStep6A("Three Panel, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][0] = [t("Drapery Three Panel, Split Draw")];
                      setExtendedTitle(tempExtended);
                      setCart("PanelTypeA", "Three Panel, Split Draw");
                      if (step2B === "None") {
                        setDeps("", "6,6A");
                      } else {
                        setDeps("", "6A");
                      }
                    }}
                    ref={(ref) => (inputs.current["6A6"] = ref)}
                  />
                  <label htmlFor="6A6">{t("Three Panel, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
                </div>
              </div>
            </div>
            {/* sheer panel type */}
            <div className="card_body card_body_radio Customize_Style_container">
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title">{t("Sheer Panel Type")}</p>
                <div
                  className={
                    step5 !== "" && parseInt(windowWidthPanelType) > 160
                      ? "grommet_curtain_button_container grommet_curtain_button_container_separated"
                      : "noDisplay"
                  }
                >
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn ${
                        step6BHead === "Rod" ? "dk_curtain_symmetric_button_on" : ""
                      }`}
                      onClick={() => {
                        if (step6BHead === "Rod") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Rod",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(2, 1);
                          setExtendedTitle(tempExtended);
                          setStep6BHead("Rod");
                          setStep6B("");
                          setDeps("6B,8", "85,86,87");
                          setCart(
                            "",
                            "",
                            "PanelTypeB,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6BHead("Rod");
                          setStep6B("");
                          setDeps("6B", "");
                          setCart("", "", "PanelTypeB");
                        }
                      }}
                    >
                      <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6BHead === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      } ${tracksList.length > 0 && step2A !== "Grommet" ? "" : "crossed"} ${
                        tracksList.length > 0 && step2C === "Grommet" ? "crossed" : ""
                      }`}
                      onClick={() => {
                        if (step6BHead === "Track") return;
                        setStep6CHead("Track");
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Track",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(2, 1);
                          setExtendedTitle(tempExtended);
                          setStep6BHead("Track");
                          setStep6B("");
                          setDeps("6B,8", "85,86,87");
                          setCart(
                            "",
                            "",
                            "PanelTypeB,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6BHead("Track");
                          setStep6B("");
                          setDeps("6B", "");
                          setCart("", "", "PanelTypeB");
                        }
                      }}
                    >
                         <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* single panel */}
              <div
                className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
                <div
                  className={
                    parseInt(windowWidthPanelType) > 160
                      ? step6BHead === "Track"
                        ? step6BHead === "Rod"
                          ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                            ? "box33 radio_style"
                            : "noDisplay"
                          : "box33 radio_style"
                        : "noDisplay"
                      : "box33 radio_style"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                        : require("../../Images/drapery/grommet/panel_type_left.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Single Panel")}
                    value="1"
                    name="step6B"
                    ref-num="6"
                    id="6B1"
                    checked={step6B === "Single Panel"}
                    onChange={(e) => {
                      setStep6B("Single Panel");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][2] = (
                        <li key="2" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Sheer Panel")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {parseInt(windowWidthPanelType) <= 160
                              ? t("Single Panel")
                              : t("Track Single Panel")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      if (step2B === "None") {
                        setDeps("", "6,6B,6C");
                        selectChanged(e);
                      } else {
                        setDeps("", "6B");
                      }
                      setCart("PanelTypeB", "Single Panel");
                    }}
                    ref={(ref) => (inputs.current["6B1"] = ref)}
                  />
                  <label htmlFor="6B1">{t("Single Panel")}</label>
                </div>
                <div
                  className={
                    step6BHead === "Rod"
                      ? step5 !== ""
                        ? parseInt(windowWidthPanelType) > 160
                          ? parseInt(windowWidthPanelType) > 320
                            ? "noDisplay"
                            : "box33 radio_style radio_recommended wide_panel_type"
                          : "box33 radio_style"
                        : "box33 radio_style"
                      : "box33 radio_style"
                  }
                >
                  <img
                    src={
                      step5 !== ""
                        ? parseInt(windowWidthPanelType) > 160 && step6BHead === "Rod"
                          ? pageLanguage === "fa"
                            ? require("../../Images/drapery/grommet/panel_type_both2.svg").default
                            : require("../../Images/drapery/grommet/panel_type_both2.svg").default
                          : pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Pair, Split Draw")}
                    value="5"
                    name="step6B"
                    ref-num="6"
                    id="6B5"
                    checked={step6B === "Pair, Split Draw"}
                    onChange={(e) => {
                      setStep6B("Pair, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][2] = (
                        <li key="2" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Sheer Panel")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {parseInt(windowWidthPanelType) <= 160
                              ? t("Pair, Split Draw")
                              : step6BHead === "Rod"
                              ? t("Rod Pair, Split Draw")
                              : t("Track Pair, Split Draw")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      setCart("PanelTypeB", "Pair, Split Draw");
                      if (step2B === "None") {
                        setDeps("", "6,6B,6C");
                        selectChanged(e);
                      } else {
                        setDeps("", "6B");
                      }
                      if (
                        step5 === "Full" &&
                        parseInt(windowWidthPanelType) > 320 &&
                        step6BHead === "Rod"
                      ) {
                        modalHandleShow("panelTypeWarning");
                      }
                    }}
                    ref={(ref) => (inputs.current["6B5"] = ref)}
                  />
                  <label htmlFor="6B5">{t("Pair, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
                </div>
              </div>

              {/* pair, split draw */}
              <div
                className={
                  step5 === "Full" && parseInt(windowWidthPanelType) > 320 ? "box100" : "noDisplay"
                }
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                }}
              >
                <div
                  className={
                    step6BHead === "Rod"
                      ? step5 === "Full"
                        ? parseInt(windowWidthPanelType) > 320
                          ? "box50 radio_style"
                          : "noDisplay"
                        : "noDisplay"
                      : "noDisplay"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                        : require("../../Images/drapery/grommet/panel_type_four.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Four Panel, Split Draw")}
                    value="6"
                    name="step6B"
                    ref-num="6"
                    id="6B7"
                    checked={step6B === "Four Panel, Split Draw"}
                    onChange={(e) => {
                      setStep6B("Four Panel, Split Draw");
                      let tempExtended = { ...extendedTitle };
                      tempExtended["6"] = tempExtended["6"] || [];
                      tempExtended["6"][1] = (
                        <li key="1" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Sheer Panel")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {t("Four Panel, Split Draw")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      if (step2B === "None") {
                        setDeps("", "6B,6C");
                      } else {
                        setDeps("", "6B,6");
                      }
                      setCart("PanelTypeB", "Four Panel, Split Draw");
                      //     selectChanged(e);
                    }}
                    ref={(ref) => (inputs.current["6B7"] = ref)}
                  />
                  <label htmlFor="6B7">{t("Four Panel, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
                </div>
                <div
                  className={
                    step6BHead === "Rod"
                      ? step5 === "Full"
                        ? parseInt(windowWidthPanelType) > 320
                          ? "box50 radio_style"
                          : "noDisplay"
                        : "noDisplay"
                      : "noDisplay"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                        : require("../../Images/drapery/grommet/panel_type_three.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Three Panel, Split Draw")}
                    value="6"
                    name="step6B"
                    ref-num="6"
                    id="6B6"
                    checked={step6B === "Three Panel, Split Draw"}
                    onChange={(e) => {
                      setStep6B("Three Panel, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][2] = (
                        <li key="2" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Sheer Panel")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {t("Three Panel, Split Draw")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      setCart("PanelTypeB", "Three Panel, Split Draw");
                      if (step2B === "None") {
                        setDeps("", "6,6B,6C");
                        selectChanged(e);
                      } else {
                        setDeps("", "6B");
                      }
                    }}
                    ref={(ref) => (inputs.current["6B6"] = ref)}
                  />
                  <label htmlFor="6B6">{t("Three Panel, Split Draw")}</label>
                </div>
              </div>

              {step2B === "None" && (
                <NextStep currentStep="6" eventKey="7">
                  {t("NEXT STEP")}
                </NextStep>
              )}
            </div>
            {/* privacy layer panel type */}
            <div
              className={
                needsStep2C && step2C !== ""
                  ? "card_body card_body_radio Customize_Style_container"
                  : "noDisplay"
              }
            >
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title">{t("Privacy Layer Panel Type")}</p>
                <div
                  className={
                    step5 !== "" && parseInt(windowWidthPanelType) > 160
                      ? "grommet_curtain_button_container grommet_curtain_button_container_separated"
                      : "noDisplay"
                  }
                >
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn ${
                        step6BHead === "Track"
                          ? "crossed"
                          : step6CHead === "Rod"
                          ? "dk_curtain_symmetric_button_on"
                          : ""
                      }`}
                      onClick={() => {
                        if (step6CHead === "Rod") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Rod",
                            id: "1",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(3, 1);
                          setExtendedTitle(tempExtended);
                          setStep6CHead("Rod");
                          setStep6C("");
                          setDeps("6C,8", "85,86,87");
                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6CHead("Rod");
                          setStep6C("");
                          setDeps("6C", "");
                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >
                        <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6CHead === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      } ${tracksList2.length > 0 && step2C !== "Grommet" ? "" : "crossed"}`}
                      onClick={() => {
                        if (step6CHead === "Track") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Track",
                            id: "1",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(3, 1);
                          setExtendedTitle(tempExtended);
                          setStep6CHead("Track");
                          setStep6C("");
                          setDeps("6C,8", "85,86,87");
                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6CHead("Track");
                          setStep6C("");
                          setDeps("6C", "");
                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >
                      <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
                <div
                  className={
                    parseInt(windowWidthPanelType) > 160
                      ? step6CHead === "Track"
                        ? step6CHead === "Rod"
                          ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                            ? "box33 radio_style"
                            : "noDisplay"
                          : "box33 radio_style"
                        : "noDisplay"
                      : "box33 radio_style"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                        : require("../../Images/drapery/grommet/panel_type_left.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Single Panel")}
                    value="1"
                    name="step6C"
                    ref-num="6"
                    id="6C1"
                    checked={step6C === "Single Panel"}
                    onChange={(e) => {
                      setStep6C("Single Panel");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Privacy Layer")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {parseInt(windowWidthPanelType) <= 160
                              ? t("Single Panel")
                              : t("Track Single Panel")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      setDeps("", "6,6C");
                      selectChanged(e);
                      setCart("PanelTypeC", "Single Panel");
                    }}
                    ref={(ref) => (inputs.current["6C1"] = ref)}
                  />
                  <label htmlFor="6C1">{t("Single Panel")}</label>
                </div>

                <div
                  className={
                    step6CHead === "Rod"
                      ? step5 !== ""
                        ? parseInt(windowWidthPanelType) > 160
                          ? parseInt(windowWidthPanelType) > 320
                            ? "noDisplay"
                            : "box33 radio_style radio_recommended wide_panel_type"
                          : "box33 radio_style"
                        : "box33 radio_style"
                      : "box33 radio_style"
                  }
                >
                  <img
                    src={
                      step5 !== ""
                        ? parseInt(windowWidthPanelType) > 160 && step6CHead === "Rod"
                          ? pageLanguage === "fa"
                            ? require("../../Images/drapery/grommet/panel_type_both2.svg").default
                            : require("../../Images/drapery/grommet/panel_type_both2.svg").default
                          : pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Pair, Split Draw")}
                    value="5"
                    name="step6C"
                    ref-num="6"
                    id="6C5"
                    checked={step6C === "Pair, Split Draw"}
                    onChange={(e) => {
                      setStep6C("Pair, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Privacy Layer")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {parseInt(windowWidthPanelType) <= 160
                              ? t("Pair, Split Draw")
                              : step6CHead === "Rod"
                              ? t("Rod Pair, Split Draw")
                              : t("Track Pair, Split Draw")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      setCart("PanelTypeC", "Pair, Split Draw");
                      setDeps("", "6,6C");
                      selectChanged(e);
                      if (
                        step5 === "Full" &&
                        parseInt(windowWidthPanelType) > 320 &&
                        step6CHead === "Rod"
                      ) {
                        modalHandleShow("panelTypeWarning");
                      }
                    }}
                    ref={(ref) => (inputs.current["6C5"] = ref)}
                  />
                  <label htmlFor="6C5">{t("Pair, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
                </div>
              </div>

              <div
                className={
                  step5 === "Full" && parseInt(windowWidthPanelType) > 320 ? "box100" : "noDisplay"
                }
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                }}
              >
                <div
                  className={
                    step6CHead === "Rod" && step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                        : require("../../Images/drapery/grommet/panel_type_four.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Four Panel, Split Draw")}
                    value="6"
                    name="step6C"
                    ref-num="6"
                    id="6C7"
                    checked={step6C === "Four Panel, Split Draw"}
                    onChange={(e) => {
                      setStep6C("Four Panel, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][2] = (
                        <li key="2" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Privacy Layer Panel")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {t("Four Panel, Split Draw")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      setDeps("", "6C,6");
                      setCart("PanelTypeC", "Four Panel, Split Draw");
                      //      selectChanged(e);
                    }}
                    ref={(ref) => (inputs.current["6C7"] = ref)}
                  />
                  <label htmlFor="6C7">{t("Four Panel, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
                </div>
                <div
                  className={
                    step6CHead === "Rod"
                      ? step5 === "Full"
                        ? parseInt(windowWidthPanelType) > 320
                          ? "box50 radio_style"
                          : "noDisplay"
                        : "noDisplay"
                      : "noDisplay"
                  }
                >
                  <img
                    src={
                      pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                        : require("../../Images/drapery/grommet/panel_type_three.svg").default
                    }
                    className="img-fluid height_auto"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Three Panel, Split Draw")}
                    value="6"
                    name="step6C"
                    ref-num="6"
                    id="6C6"
                    checked={step6C === "Three Panel, Split Draw"}
                    onChange={(e) => {
                      setStep6C("Three Panel, Split Draw");
                      let tempExtended = extendedTitle;
                      tempExtended["6"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Privacy Layer")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {t("Three Panel, Split Draw")}
                          </span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                      setCart("PanelTypeC", "Three Panel, Split Draw");
                      setDeps("", "6,6C");
                      selectChanged(e);
                    }}
                    ref={(ref) => (inputs.current["6C6"] = ref)}
                  />
                  <label htmlFor="6C6">{t("Three Panel, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
                </div>
              </div>

              <NextStep currentStep="6" eventKey="7">
                {t("NEXT STEP")}
              </NextStep>
            </div>
            <div
              className={
                needsStep2C && step2C === ""
                  ? "card_body card_body_radio Customize_Style_container"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">{t("Privacy Layer Panel Type")}</p>
              </div>
              <div className="checkbox_text_info_container">
                <div className="card-body-display-flex">
                  <span className="checkbox_text">{t("pl_hs_incomplete")}</span>
                </div>
              </div>
              <NextStep currentStep="6" eventKey="7">
                {t("NEXT STEP")}
              </NextStep>
            </div>
          </div>
          {showPanelTypeGrid && (
            <div className="accordion_help">
              <div className={`help_container ${pageLanguage === "fa" ? "help_container_fa" : ""}`}>
                <div className="help_column help_left_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_1")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step61"] === undefined
                                        ? require("../../Images/drapery/grommet/single_panel.jpg")
                                        : popoverImages["step61"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_1")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/single_panel.jpg")}
                                        text="step61"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_2")}
                    </li>
                    <li>{t("grommet_panel_type_help_3")}</li>
                  </ul>
                </div>
                <div className="help_column help_right_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_4")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step52"] === undefined
                                        ? require("../../Images/drapery/grommet/pair_panel.jpg")
                                        : popoverImages["step52"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_6")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/pair_panel.jpg")}
                                        text="step52"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_6")}
                    </li>
                    <li>{t("grommet_panel_type_help_7")}</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
